import React,{ useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';

import  { AutoPostImageUploader } from './ImageUploader';

const BulkImageUploader = ({ auto_url, auto_type, ...props }) => {
	const [ images, setImages ] = useState(false);

	const size = props.size ?? { width:400, height:400 };

	const fileAdded = (file, xhr, formData) => {
		setImages((images) => {
			if(images == false) return [ { name:file.name } ];
			return [ ...images, { name:file.name } ];
		});
	};

	const change = (k, v, file, full) => {
		if(k == 'full_image') return;
		setImages((images) => (images.filter((i) => i.name != file )));
		props.change(k, v, file, full);
	};

	useEffect(() => {
		if(!images) return;

		if(images.length == 0 && props.onFinish != undefined) props.onFinish();
	}, [ images ]);

	return (
		<div>
			<ul>
				{images && images.map((image, i) => (
					<div key={`image_${i}`}>
						{image.name}
					</div>
				))}
			</ul>

			<AutoPostImageUploader
				{...props}
				auto_url={auto_url}
				auto_type={auto_type}
				fileAdded={fileAdded}
				change={change}
				_class={{first:true}}
				name='image'
				max_items={props.max_items}
				//display_custom_dragging_instructions="Upload the image"
				_size={size}
			>{props.children}</AutoPostImageUploader>
		</div>
	)
};

export default injectIntl(BulkImageUploader);